import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
} from "@ionic/react";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

interface IonOptiModalProps {
    trigger: string;
    title?: string;
    children?: JSX.Element;
    onConfirmCb?: () => void;
    onCancelCb?: () => void;
    cancelText?: string;
    confirmText?: string;
}
export default function IonOptiModal(props: IonOptiModalProps) {
    const { t } = useTranslation();
    const modal = useRef<HTMLIonModalElement>(null);
    return (
        <IonModal ref={modal} trigger={props.trigger}>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton
                            onClick={() => {
                                props.onCancelCb && props.onCancelCb();
                                modal.current?.dismiss();
                            }}
                        >
                            {props.cancelText || t("cancel")}
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{props.title}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton strong onClick={() => modal.current?.dismiss()}>
                            {props.confirmText || t("accept")}
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">{props.children}</IonContent>
        </IonModal>
    );
}
